/**
 * Animation configuration for progress bar
 */

import { colors } from '../../../common/constants/designTokens';

export const PROGRESS_BAR_ANIMATION = {
  // Duration in seconds for the stripe animation
  duration: 30,
  // Distance the stripes should move (in pixels) - should match one full pattern cycle
  distance: 1000,
  // Stripe pattern configuration
  stripeSize: 10, // Size of each stripe segment (light + dark = 20px total)
  // Animation timing function
  timingFunction: 'linear',
  // Animation iteration
  iteration: 'infinite',
  // Failed state opacity
  failedOpacity: 0.5,
  // Colors for different states
  colors: {
    completed: {
      light: colors.primary[300], // Light green stripe
      dark: colors.primary[500], // Tazkiyah green stripe
    },
    remaining: {
      light: '#e5e7eb', // Gray 200
      dark: '#d1d5db', // Gray 300
    },
    failed: {
      light: '#9ca3af', // Gray 400
      dark: '#d1d5db', // Gray 300
    },
  },
} as const;

/**
 * Generates the repeating linear gradient for stripes
 */
export const generateStripeGradient = (
  lightColor: string,
  darkColor: string,
  stripeSize: number = PROGRESS_BAR_ANIMATION.stripeSize
): string => {
  return `repeating-linear-gradient(45deg, ${lightColor}, ${lightColor} ${stripeSize}px, ${darkColor} ${stripeSize}px, ${darkColor} ${stripeSize * 2}px)`;
};

/**
 * Generates keyframe animation CSS
 */
export const generateStripeAnimation = (
  name: string,
  distance: number = PROGRESS_BAR_ANIMATION.distance
): string => {
  return `
    @keyframes ${name} {
      from { background-position: 0 0; }
      to { background-position: ${distance}px 0; }
    }
  `;
};
